'use strict'

resizeFlg = {}
resizeFlg.pc = true
resizeFlg.sp = true
firstView = ''

spFixAnchor = ()->
  if $('.p-anchor.js-headroom').length
    offset = $('.p-anchor.js-headroom').offset()

    $('.p-anchor.js-headroom').headroom({
      offset: offset.top
    })

    $(window).on('scroll',
      ()->
        if ($(this).scrollTop() + $(window).height()) > $('.p-footer').offset().top
          $('.p-anchor.js-headroom').addClass('is-bottom')
        else
          $('.p-anchor.js-headroom').removeClass('is-bottom')
    )

$('#operations').find('input[name=operation]').on('change', ()->
# $('#operations').find('.p-operations__check__link a').on('click', ()->
  # チェックされたvalue値を配列として取得
  vals = $('input[name=operation]:checked').map(()->
    $(this).val()
  ).get()

  counts = {}
  i = 0

  while i < vals.length
    key = vals[i]

    counts[key] = if counts[key] then counts[key] + 1 else 1

    i++

  counts = Object.entries(counts)

  counts.sort((a, b)->
    if a[1] < b[1]
      return 1
    if a[1] > b[1]
      return -1
    return 0
  )

  $('#recommend').find('.p-operations__item').removeClass('is-active').addClass('is-hide').removeAttr('style')

  $('#recommend').find('.p-operations__item').each(
    ()->
      if $(this).hasClass('is-open')
        $(this).find('.js-accordion__button').trigger('click', 'trigger')
  )

  if counts.length is 0
    $('#recommend').find('.p-operations__item').removeClass('is-hide').removeAttr('style')

  $('#recommend').find('.p-operations__item').each(
    ()->
      $target = $(this)

      $(counts).each(
        (key, val)->
          if $target.hasClass($(this)[0])
            $target.removeClass('is-hide')
            $target.addClass('is-active')
            $target.css('order', (key + 1))
      )

      if counts.length isnt 0 and $target.hasClass(counts[0][0])
        $target.addClass('is-open-initially')
        $target.find('.js-accordion__button').trigger('click', 'trigger')
  )

  $('#others').find('.p-operations__item').removeClass('is-hide')

  $('#others').find('.p-operations__item').each(
    ()->
      $target = $(this)

      $(counts).each(
        (key, val)->
          if $target.hasClass($(this)[0])
            $target.addClass('is-hide')
      )
  )

  if counts.length is 0 or counts.length is $('#recommend').find('.p-operations__item').length
    $('#others').removeClass('is-active')
  else
    $('#others').addClass('is-active')
)

$('.close').on('click', ()->
  $parent = $root = $(this).closest('.item-inner')
  $parent.removeClass('is-close')
  $parent.toggleClass('is-open')
)

$('.open').on('click', ()->
  $parent = $root = $(this).closest('.item-inner')
  $parent.removeClass('is-open')
  $parent.toggleClass('is-close')
)

if window.matchMedia('(max-width:750px)').matches
  # SP
  firstView = 'SP'

  spFixAnchor()

  $('.icon.question').on('click', ()->
    $(this).toggleClass('is-active')
  )
else
  # PC
  firstView = 'PC'

  spFixAnchor()

$(window).on('resize',
  ()->
    if window.matchMedia('(max-width:750px)').matches
      if firstView is 'PC' and resizeFlg.sp is true or
      firstView is false and resizeFlg.sp is true
        # PC から SP へ

        resizeFlg.pc = true
        resizeFlg.sp = false
        firstView = false
    else
      if firstView is 'SP' and resizeFlg.pc is true or
      firstView is false and resizeFlg.pc is true
        # SP から PC へ

        resizeFlg.pc = false
        resizeFlg.sp = true
        firstView = false

        $('.icon.question').off('click')
)
